const MAGNITUDES = [7.8, 8.0, 8.2, 8.4, 8.6, 8.8, 9.0, 9.2, 9.4];

export function snapToNearest(num) {
  if (num <= MAGNITUDES[0]) return MAGNITUDES[0];
  if (num >= MAGNITUDES[MAGNITUDES.length - 1]) return MAGNITUDES[MAGNITUDES.length - 1];
  let nearest = MAGNITUDES[0];
  let minDiff = Infinity;
  for (const mag of MAGNITUDES) {
    const diff = Math.abs(num - mag);
    if (diff < minDiff - 1e-9 || (Math.abs(diff - minDiff) < 1e-9 && mag > nearest)) {
      minDiff = diff;
      nearest = mag;
    }
  }
  return nearest;
}
